import idx from 'idx';
import { fetchPricing } from 'pap/ducks/pricing';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formValueSelector } from 'redux-form';
import { fetchCategoriesIfNeeded, getSubCategory } from 'common/ducks/categories';
import Packages from 'marketing/components/pricing_packages';
import { withRouter } from 'react-router';

export function mapStateToProps(state, {
  formName, showDifferentiators, showTestimonial, showReviewsAgg, showCta
}) {
  const selector = formValueSelector(formName);
  const selectedSubcategory = selector(state, 'category');
  const packages = idx(state, _ => _.pap.pricing.packages) || [];
  return {
    category: selectedSubcategory,
    subCategory: getSubCategory(state.categories, selectedSubcategory),
    showDifferentiators: showDifferentiators === undefined? true : showDifferentiators,
    showTestimonial: showTestimonial === undefined? true : showTestimonial,
    showReviewsAgg: showReviewsAgg === undefined? true : showReviewsAgg,
    showCta: showCta === undefined? true : showCta,
    packages,
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchPricing,
    fetchCategoriesIfNeeded,
  }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Packages));
